import { useService } from "./service.js";
function createLoadService() {
  function onLoad() {
    props.time = window.performance.now();
    trigger(props);
  }
  const { add, remove, has, props, trigger } = useService({
    /**
     * @type {LoadServiceProps}
     */
    props: {
      time: performance.now()
    },
    init() {
      window.addEventListener("load", onLoad);
    },
    kill() {
      window.removeEventListener("load", onLoad);
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let load;
function useLoad() {
  if (!load) {
    load = createLoadService();
  }
  return load;
}
export {
  useLoad as default
};
//# sourceMappingURL=load.js.map
